/**
 * Persist planner month-view density: week row count target (viewport split).
 */

export const STORAGE_KEY_PLANNER_CALENDAR_WEEK_ROWS = 'planner_calendar_week_rows_visible';

/** @returns {5 | 6} */
export function loadWeekRowsVisibleFromStorage() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY_PLANNER_CALENDAR_WEEK_ROWS);
    if (raw == null || raw === '') return 6;
    const n = Number(raw);
    return n === 5 || n === 6 ? n : 6;
  } catch {
    return 6;
  }
}

/** @param {5 | 6} n */
export function persistWeekRowsVisible(n) {
  if (n !== 5 && n !== 6) return;
  try {
    localStorage.setItem(STORAGE_KEY_PLANNER_CALENDAR_WEEK_ROWS, String(n));
  } catch {
    /* ignore */
  }
}
